import { ERRORCODE } from './constants/ErrorCode'
import i18n from './i18n';

// union two object
export const unionObject = (target, source) => {
    return Object.keys(target).reduce((obj, key) => {
        if (source.hasOwnProperty(key) && source[key] !== null) {
            obj[key] = source[key];
        } else {
            obj[key] = target[key];
        }
        return obj;
    }, {});
}

// Convert PHP Unix Timestamp to Javascript Timestamp format
export const convertTimestamp = (time) => {
    let string = parseInt(time) * 1000;
    let datetime = new Date(string).toLocaleString();
    return datetime;
}

export const convertTimestampToDate = (time) => {
    let string = parseInt(time) * 1000;
    let datetime = new Date(string);
    let mm = datetime.getMonth() + 1;
    let dd = datetime.getDate();
    let yyyy = datetime.getFullYear();
    let format = yyyy + '/' + mm + '/' + dd;
    return format;
}

export const validateEmail = (email) => {
    let regex = /\S+@\S+\.\S+/;
    return email.match(regex)
}

export const validateNumber = (number) => {
    let regex = /^[0-9]*$/;
    return regex.test(number)
}

export const validateNotDot = (number) => {
    let regex = /\./;
    return !regex.test(number)
}

export const validateDomain = (domain) => {
    let regex = /^[a-zA-Z0-9]*$/;
    return regex.test(domain) && domain.length <= 63
}

export const getDisplayBalance = (balance) => {
    return (balance > 0) ? "-$" + balance : "$" + Math.abs(balance)
}

// Get current access token
export const getAccessToken = () => (localStorage.getItem("access_token"));

// get current logined user id
export const getUserId = () => (localStorage.getItem("id"));

// create config for api
export const getConfig = () => ({ headers: { "Authorization": "Bearer " + getAccessToken() } })

// catch error
export const catchMessageError = (code, index='') => {
    if (index !== '') {
        let error = ""
        switch (code) {
            case "P002":
                error = i18n.t('Project name') + index + i18n.t('has already been taken')
                break;

            case "P005":
                error = i18n.t('Invalid Input') + index
                break;

            case "F0011":
                error = i18n.t('Missing') + index + i18n.t('param')
                break

            case "S001":
                error = i18n.t('Param ') + index + i18n.t(' is not allowed')
                break;

            case "S002":
                error = i18n.t('Missing param ') + index
                break;

            default:
                break;
        }
        return error
    }
    return ERRORCODE.hasOwnProperty(code) ? i18n.t(ERRORCODE[code]) : i18n.t(ERRORCODE['defa'])
}

// get project status
export const projectStatusText = {
    "-2": "DEPLOY FAIL",
    "-1": "INACTIVE",
    "0": "PAUSE",
    "1": "ACTIVE",
    "2": "IN TRANSACTION",
    "3": "PAID",
    "4": "DEPLOYING",
    "5": "UNPAID",
    "6": "VERIFYING PAYMENT",
    "8": "VERIFY FAIL"
}
export const projectStatusClassName = {
    "-2": "m-badge m-badge--danger m-badge--wide",
    "-1": "m-badge m-badge--metal m-badge--wide",
    "0": "m-badge m-badge--pending m-badge--wide",
    "1": "m-badge m-badge--accent m-badge--wide",
    "2": "m-badge m-badge--brand m-badge--wide",
    "3": "m-badge m-badge--success m-badge--wide",
    "4": "m-badge m-badge--warning m-badge--wide",
    "5": "m-badge m-badge--secondary m-badge--wide",
    "6": "m-badge m-badge--pink m-badge--wide",
    "8": "m-badge m-badge--danger m-badge--wide"
}

export const readUploadedFileAsBinaryString = inputFile => {
    const temporaryFileReader = new FileReader();

    return new Promise(async (resolve, reject) => {
        try {
            temporaryFileReader.onload = () => {
               resolve(temporaryFileReader.result)
            }
            await temporaryFileReader.readAsBinaryString(inputFile)
        } catch (err) {
            temporaryFileReader.abort()
            reject(err.message)
        }
    })
}


